import type { VoidFunctionComponent } from 'react';
import Button from '../../../generic/Button';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import { EditDependencyModal } from '../../modals';

/**
 * IssueDetailsActionButtonEditPackage includes the button and the modal
 * for the Edit Package action button.
 */
const IssueDetailsActionButtonEditPackage: VoidFunctionComponent = () => {
  const { editPackageModal, isAnyModalOpen } = useIssueDetailsModals();
  return (
    <>
      <Button
        type="secondary"
        size="medium"
        onClick={editPackageModal.onOpen}
        isDisabled={isAnyModalOpen}
      >
        Edit Package
      </Button>
      <EditDependencyModal
        isOpen={editPackageModal.isOpen}
        onHide={editPackageModal.onClose}
      />
    </>
  );
};

export default IssueDetailsActionButtonEditPackage;
